import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  margin-bottom: ${theme.spacings.bit};
`

const tagStyles = ({ theme }: Theme) => css`
  label: applied-filters__tag;

  display: flex;
  align-items: center;

  padding: ${theme.spacings.bit} ${theme.spacings.byte};
  margin-top: ${theme.spacings.kilo};

  background-color: ${theme.colors.p600};
  border-radius: 20px;
`

const tagLabelStyles = ({ theme }: Theme) => css`
  label: applied-filters__tag-label;

  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  font-weight: ${theme.font.weight.semibold};
  line-height: 15px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${theme.colors.white};
  
  max-width: 200px;
`

const tagCloseButtonStyles = ({ theme }: Theme) => css`
  label: applied-filters__tag-close-button;

  padding: 0;

  color: ${theme.colors.white};

  & > svg {
    cursor: pointer;
    margin-left: ${theme.spacings.bit};
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const Tag = styled('div')(tagStyles)
export const Label = styled('span')(tagLabelStyles)
export const ButtonClose = styled('button')(tagCloseButtonStyles)
